import { useState } from "react";
import Logo from "../assets/logo.png";
import { FaBars } from "react-icons/fa";

const TopbarMobile = ({ onOpenSidebar }) => {
  return (
    <div className="sm:hidden flex items-center justify-between px-4 py-3 bg-white/10 backdrop-blur-md shadow-md fixed top-0 left-0 w-full z-50">
      <img src={Logo} alt="Logo" className="w-10 h-10 rounded-full" />
      <button onClick={onOpenSidebar}>
        <FaBars className="text-white w-6 h-6" />
      </button>
    </div>
  );
};

export default TopbarMobile;
